import { Link, NavLink } from "react-router-dom";

const Navigation = () => {
  return (
    <div className="flex flex-col sm:flex-row mb-4 mt-4 text-lg">
      <span className="ml-2 mb-2 sm:mb-0 sm:mr-2 text-orange-800">Navigation</span>
      <span className="mb-2 sm:mb-0 sm:mr-2">
        <NavLink to="home">Home</NavLink>
      </span>
      <span>
        <NavLink to="gallery">Gallery</NavLink>
      </span>
    </div>
  );
};

export default Navigation;
